import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import QCModalHeader from "../../../../../components/Modal/QCModalHeader";
import QCModalFooter from "../../../../../components/Modal/QCModalFooter";
import { checkIfActiveRequestExists, sendOldStudyAccessRequest, sendOldStudyAccessRequest2 } from "../../../../../service/StudyListService";
import {
  DefaultButton,
  IconButton,
  Modal,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import userContext from "../../../../../context/users/UserContext";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import themeContext from "../../../../../context/theme/ThemeContext";
import ModalMain from "../../../../../components/Modal/ModalMain";
import { getEnv } from '../../../../../helpers/EnvHelper';

const ImageArchivalAccessForm = (props) => {
  const { t } = useTranslation();
  const [archivalReason, setArchivalReason] = useState("");
  const [error, setError] = useState("");
  const { userId } = useContext(userContext)
  const { getThemeColor } = useContext(themeContext);
  const [requestExists, setRequestExists] = useState(false);

  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM")=="true"||getEnv("REACT_APP_VDC_PLATFORM")==true)?true:false;

  useEffect(() => {
    // if(isVdcPlatform){
      const checkRequest = async () => {
        try {
          const res = await checkIfActiveRequestExists(props.row.original.id);
          console.log(res)
          setRequestExists(res.data.data);
        } catch (err) {
          console.error("Error checking active request", err);
          setRequestExists(false); 
        }
      };
      checkRequest();
    // }
  }, [props.row.original.id]);

  const handleCancel = () => {
    props.setOpenImageArchivalForm(false);
    return false;
  };

  const handleOK = async () => {
    // if (archivalReason === "") {
    //   setError(true);
    //   return;
    // }
    // const response = isVdcPlatform 
    //   ? await sendOldStudyAccessRequest2(props.row.original.id, archivalReason, userId) 
    //   : await sendOldStudyAccessRequest( props.row.original.id, archivalReason);

    const response = await sendOldStudyAccessRequest2(props.row.original.id, archivalReason, userId) 
      
    console.log(response.data.message);
    props.setOpenImageArchivalForm(false);
    props.setOpenImageArchivalAccessConfirmation(true);
    props.setOpenImageArchivalAccessConfirmationMessage(response.data.message);
    return true;
  };

  const PrimaryButtonList = [
    {
      title: "Request Access",
      onclick: handleOK,
      disabled: requestExists == true,
    },
  ];
  const DefaultButtonList = [
    {
      title: "Cancel",
      onclick: handleCancel,
    },
  ];

  const handleArchivalReasonChange = (e) => {
    setArchivalReason(e.target.value);
  };

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={props.title}
        handleCancel={handleCancel}
      />
    ),
    body: <div className="global-modal-body" style={{ color: getThemeColor("primary-color") }}>
      {requestExists == true ? (
            <p>
              Request already generated for this study. Pending for approval. Check after some time.
            </p>) : (
      <div className="message-container">
        <h1 className="confirm-message">{props.message}</h1>

        <TextField
          className="form-field"
          name="archivalReason"
          placeholder="Type reason to access this case"
          label="Reason (optional)"
          maxLength={100}
          onChange={handleArchivalReasonChange}
          value={archivalReason}
          errorMessage={error ? t("image-archive.valid-reason") : ""}
        />

      </div>)}
    </div>,
    footer: <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList} />,
    width: "700px",
  };

  return (
    <>
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
    </>
  )
};

export default ImageArchivalAccessForm;
